import {
  initializeWasm,
  setDeviceAndDeviceType,
  usbDisconnect,
  SELECTEDDEVICE,
  onDeviceDisconnect,
} from "./protocol";

export { onDeviceDisconnect };

export async function requestDevice(filters: HIDDeviceFilter[]): Promise<HIDDevice> {
  const devices = await navigator.hid.requestDevice({ filters });
  if (devices.length > 0) return devices[0];
  throw new Error("No device found");
}

export async function connectDevice(): Promise<void> {
  if (typeof window === "undefined") throw new Error("Must run in browser.");
  try {
    const filters: HIDDeviceFilter[] = [{ vendorId: 0x1915 }, { vendorId: 0x3723 }];
    const device = await requestDevice(filters);
    await initializeWasm();
    await setDeviceAndDeviceType(device);
  } catch (error: any) {
    let message = error.message;
    if (message?.includes("Device has disconnected")) {
      message = "The device is in use by another app. Close it and try again.";
    }
    throw new Error(message);
  }
}

export function checkDevice(): boolean {
  return Boolean(SELECTEDDEVICE);
}

export async function disconnectDevice(): Promise<void> {
  await usbDisconnect();
}
